import React, { useState, useEffect } from "react";
import { auth, db } from "../../firebase";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function Perfil() {
  const navigate = useNavigate();
  const [usuarioLogueado, setUsuarioLogueado] = useState(null);
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    // Escuchar si el usuario está firmado o no
    const desubscribir = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUsuarioLogueado(user);
        // Jalar su expediente desde Firestore
        const docRef = doc(db, "usuarios", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const datos = docSnap.data();
          setNombre(datos.nombreCompleto || "");
          setTelefono(datos.telefono || "");
        }
      } else {
        // Si no está logueado, lo mandamos al login de inmediato
        navigate("/login");
      }
      setCargando(false);
    });

    return () => desubscribir();
  }, [navigate]);

  const handleActualizarPerfil = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setMensaje("");

    try {
      const docRef = doc(db, "usuarios", usuarioLogueado.uid);
      await updateDoc(docRef, {
        nombreCompleto: nombre,
        telefono: telefono,
      });
      setMensaje("✅ Perfil actualizado correctamente.");
    } catch (error) {
      console.error("Error al actualizar perfil:", error);
      setMensaje("❌ No se pudieron guardar los cambios.");
    } finally {
      setGuardando(false);
    }
  };

  const handleCerrarSesion = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  if (cargando) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f4f4f6",
        }}
      >
        <p style={{ fontSize: "16px", fontWeight: "700" }}>
          Cargando tus datos míticos...
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#f4f4f6",
        minHeight: "100vh",
        padding: "20px",
        fontFamily: "-apple-system, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          width: "100%",
          maxWidth: "450px",
          borderRadius: "24px",
          padding: "24px",
          boxSizing: "border-box",
          margin: "0 auto",
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        }}
      >
        {/* ENCABEZADO */}
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              backgroundColor: "#111",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "28px",
              fontWeight: "800",
              margin: "0 auto 12px auto",
            }}
          >
            {nombre ? nombre.charAt(0).toUpperCase() : "M"}
          </div>
          <h3
            style={{ margin: "0 0 4px 0", fontSize: "20px", fontWeight: "900" }}
          >
            Mi Perfil Mítico
          </h3>
          <p style={{ margin: 0, fontSize: "13px", color: "#666" }}>
            {usuarioLogueado?.email}
          </p>
        </div>

        {mensaje && (
          <div
            style={{
              padding: "12px",
              backgroundColor: mensaje.startsWith("✅") ? "#e6f4ea" : "#fce8e6",
              color: mensaje.startsWith("✅") ? "#137333" : "#c5221f",
              borderRadius: "10px",
              fontSize: "13px",
              fontWeight: "600",
              marginBottom: "16px",
            }}
          >
            {mensaje}
          </div>
        )}

        {/* FORMULARIO DE EDICIÓN */}
        <form
          onSubmit={handleActualizarPerfil}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            textAlign: "left",
          }}
        >
          <div>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "700",
                marginBottom: "6px",
                color: "#444",
              }}
            >
              Nombre Completo
            </label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid #ccc",
                boxSizing: "border-box",
                fontSize: "14px",
              }}
            />
          </div>

          <div>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "700",
                marginBottom: "6px",
                color: "#444",
              }}
            >
              Teléfono de Contacto
            </label>
            <input
              type="tel"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              placeholder="33 1234 5678"
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid #ccc",
                boxSizing: "border-box",
                fontSize: "14px",
              }}
            />
          </div>

          <button
            type="submit"
            disabled={guardando}
            style={{
              width: "100%",
              backgroundColor: "#000",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              padding: "14px",
              fontSize: "14px",
              fontWeight: "700",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            {guardando ? "Guardando..." : "Guardar Cambios"}
          </button>
        </form>

        <hr
          style={{
            border: "none",
            borderTop: "1px solid #eee",
            margin: "24px 0",
          }}
        />

        {/* BOTONES ADICIONALES */}
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <button
            onClick={() => navigate("/")}
            style={{
              width: "100%",
              backgroundColor: "#fff",
              color: "#111",
              border: "1px solid #111",
              borderRadius: "12px",
              padding: "12px",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            🛒 Ir a la Tienda
          </button>

          <button
            onClick={handleCerrarSesion}
            style={{
              width: "100%",
              backgroundColor: "#fff",
              color: "#d93025",
              border: "1px solid #fce8e6",
              borderRadius: "12px",
              padding: "12px",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            🚪 Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  );
}

export default Perfil;
